import ProperClothing from "../Ui/properclothing.jpg";
import WashHands from "../Ui/washhands.jpg";
import CoronaResearch from "../Ui/research.jpg";
import Nitrogen from "../Ui/nitrogen.jpg";
import Spectrocopy from "../Ui/spectrocopy.jpg";
import Virus from "../Ui/sliderImg1.jpg";

const blogs = [
  {
    id: 7,
    image: `${ProperClothing}`,
    name: "The Importance of Wearing Proper Medical Clothing",
    desp: "Proper medical clothing helps prevent contamination, ensures the safety of both patients and healthcare professionals, and maintains a sterile environment. From masks to gloves to lab coats, each piece plays a crucial role in infection control.",
    likes: 120,
    views: 980,
    readTime: "3 min read",
    tag: "Safety",
  },
  {
    id: 8,
    image: `${Virus}`,
    name: "How COVID-19 Reshaped Our Lives and Healthcare Systems",
    desp: "The coronavirus pandemic exposed weaknesses in global healthcare systems. This article dives into the social, economic, and medical implications of the virus, exploring how it changed hospital protocols and reshaped human behavior.",
    likes: 230,
    views: 1420,
    readTime: "4 min read",
    tag: "COVID-19",
  },
  {
    id: 9,
    image: `${WashHands}`,
    name: "Why You Should Wash Your Hands for 20 Seconds",
    desp: "Handwashing is one of the most effective ways to prevent the spread of infections. Learn how the 20-second rule eliminates germs and why soap and water beat hand sanitizers in most cases.",
    likes: 85,
    views: 760,
    readTime: "2 min read",
    tag: "Hygiene",
  },
  {
    id: 10,
    image: `${CoronaResearch}`,
    name: "Inside the Lab: Coronavirus Vaccine Research Explained",
    desp: "Go behind the scenes of a biomedical lab where scientists are racing against time to develop vaccines and antiviral treatments for COVID-19. This piece outlines the phases of vaccine testing and public distribution challenges.",
    likes: 198,
    views: 1100,
    readTime: "5 min read",
    tag: "Research",
  },
  {
    id: 11,
    image: `${Nitrogen}`,
    name: "Liquid Nitrogen vs Mechanical Freezers: What's the Difference?",
    desp: "Explore the science and use cases behind cryopreservation. This blog compares liquid nitrogen systems with traditional mechanical freezers and evaluates which is more efficient for biological sample storage.",
    likes: 60,
    views: 650,
    readTime: "4 min read",
    tag: "Technology",
  },
  {
    id: 12,
    image: `${Spectrocopy}`,
    name: "Spectroscopy in Modern Labs: Tools and Techniques",
    desp: "Spectroscopy helps identify chemical structures by analyzing light interactions. This post introduces you to key techniques like IR, UV-Vis, and NMR spectroscopy used in diagnostics and research.",
    likes: 95,
    views: 740,
    readTime: "3 min read",
    tag: "Lab Tech",
  },
];

export default blogs;
